import { useAtomValue } from 'jotai';

import { getAppConfig } from '../config';
import { useContactUs } from '../useContactUs';
import { ProviderNotHereDescription, ProviderNotHereDescriptionProps } from './ProviderNotHereDescription';
import { useChatDrawerButtonUtils } from './chat/useChatDrawerButtonUtils';
import { VisitorDrawerState, providerIsOnlineAtom, visitorDrawerStateAtom } from './state';

export type ProviderNotHereDescriptionWrapperProps = Omit<
  ProviderNotHereDescriptionProps,
  'providerIsOnline' | 'onOpenChatDrawer' | 'contactUsUrl' | 'marketplaceOrigin'
>;

export function ProviderNotHereDescriptionWrapper(props: ProviderNotHereDescriptionWrapperProps) {
  const { toggleChatDrawer } = useChatDrawerButtonUtils();
  const drawerState = useAtomValue(visitorDrawerStateAtom);
  const providerIsOnline = useAtomValue(providerIsOnlineAtom);
  const { pageUrl: contactUsUrl } = useContactUs();

  return (
    <ProviderNotHereDescription
      providerIsOnline={providerIsOnline}
      contactUsUrl={contactUsUrl}
      marketplaceOrigin={getAppConfig().marketplaceOrigin}
      onOpenChatDrawer={() => {
        if (drawerState !== VisitorDrawerState.CHAT) {
          toggleChatDrawer();
        }
        props.onClose();
      }}
      {...props}
    />
  );
}
